import { SupportChannels } from '@jotta/ui/SupportChannels'
import { Trans } from '@lingui/macro'
import { ErrorMessage } from '@jotta/ui/ErrorMessage'

export function ProductNotFound({
  customerGroupOverride,
}: {
  customerGroupOverride?: string
}) {
  return (
    <div className="mx-auto max-w-md px-8 py-16">
      <ErrorMessage className="my-8">
        <header>
          <Trans>No product found</Trans>
        </header>
        <p className="pt-4">
          <Trans>
            We could not find a suitable product for you, please contact
            support!
          </Trans>
        </p>
      </ErrorMessage>
      <SupportChannels customerGroupOverride={customerGroupOverride} />
    </div>
  )
}
